import React from "react";
import Home from "./components/home/index";

export default function App() {
	return <Home />;
}

